<script setup lang="ts">
import type { AcademyLink } from '#academy-virtual/types'
import type { Props as SlideoverProps } from './AcademySlideover.vue'
import { Button } from '@forgd/ui-kit/button'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'
import Slideover from './AcademySlideover.vue'

export interface Props {
  path: AcademyLink
  slideover?: Omit<SlideoverProps, 'path'>
}

defineProps<Props>()

const isOpen = ref(false)

function close() {
  isOpen.value = false
}
</script>

<template>
  <Button v-bind="$attrs" @click="isOpen = true">
    <slot>
      Readings & Resources
      <ArrowRightIcon aria-hidden="true" />
    </slot>
  </Button>
  <Slideover
    :is-open="isOpen"
    :path="path"
    v-bind="slideover"
    @close="close"
  />
</template>
